module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_8023.ee09ba56.png";